var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlayStoreButton = function SvgPlayStoreButton(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 54,
    viewBox: "0 0 182 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.881836,
    y: 0.00012207,
    width: 181.118,
    height: 53.6646,
    rx: 7.82609,
    fill: "#141416"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2941 29.1816C89.1386 29.1816 86.5667 31.5817 86.5667 34.8875C86.5667 38.1731 89.1386 40.5934 92.2941 40.5934C95.4509 40.5934 98.0227 38.1731 98.0227 34.8875C98.0214 31.5817 95.4495 29.1816 92.2941 29.1816ZM92.2941 38.3475C90.5647 38.3475 89.0742 36.9214 89.0742 34.8888C89.0742 32.8348 90.5661 31.4301 92.2941 31.4301C94.0234 31.4301 95.5139 32.8348 95.5139 34.8888C95.5139 36.92 94.0234 38.3475 92.2941 38.3475ZM79.7982 29.1816C76.6428 29.1816 74.0709 31.5817 74.0709 34.8875C74.0709 38.1731 76.6428 40.5934 79.7982 40.5934C82.9551 40.5934 85.527 38.1731 85.527 34.8875C85.527 31.5817 82.9551 29.1816 79.7982 29.1816ZM79.7982 38.3475C78.0689 38.3475 76.5784 36.9214 76.5784 34.8888C76.5784 32.8348 78.0702 31.4301 79.7982 31.4301C81.5276 31.4301 83.0181 32.8348 83.0181 34.8888C83.0195 36.92 81.5276 38.3475 79.7982 38.3475ZM64.9358 30.9337V33.354H70.7289C70.5559 34.7158 70.1024 35.7099 69.4101 36.4008C68.5676 37.2434 67.2488 38.1731 64.9358 38.1731C61.3698 38.1731 58.582 35.298 58.582 31.732C58.582 28.166 61.3698 25.2909 64.9358 25.2909C66.8597 25.2909 68.2644 26.0476 69.3015 27.0203L71.0093 25.3124C69.5604 23.9292 67.6379 22.8706 64.9358 22.8706C60.051 22.8706 55.9443 26.8472 55.9443 31.732C55.9443 36.6168 60.051 40.5934 64.9358 40.5934C67.5721 40.5934 69.5617 39.728 71.1167 38.1074C72.7159 36.5082 73.2136 34.2596 73.2136 32.4444C73.2136 31.8836 73.1707 31.3644 73.0835 30.9324H64.9358V30.9337ZM125.722 32.8133C125.247 31.5388 123.798 29.1816 120.837 29.1816C117.897 29.1816 115.454 31.4945 115.454 34.8875C115.454 38.0859 117.876 40.5934 121.117 40.5934C123.732 40.5934 125.245 38.9942 125.873 38.0644L123.928 36.7671C123.28 37.7183 122.393 38.3448 121.117 38.3448C119.843 38.3448 118.934 37.7612 118.351 36.6155L125.981 33.46L125.722 32.8133ZM117.94 34.7158C117.876 32.5101 119.648 31.3872 120.924 31.3872C121.918 31.3872 122.761 31.8849 123.043 32.5973L117.94 34.7158ZM111.738 40.2486H114.244V23.477H111.738V40.2486ZM107.63 30.4575H107.544C106.982 29.7867 105.901 29.1816 104.54 29.1816C101.687 29.1816 99.0719 31.6891 99.0719 34.9103C99.0719 38.1087 101.687 40.5947 104.54 40.5947C105.902 40.5947 106.982 39.9896 107.544 39.2987H107.63V40.1198C107.63 42.3026 106.463 43.4698 104.583 43.4698C103.048 43.4698 102.097 42.3683 101.708 41.4386L99.5254 42.3469C100.152 43.8589 101.815 45.7183 104.583 45.7183C107.523 45.7183 110.009 43.989 110.009 39.7736V29.5291H107.631V30.4575H107.63ZM104.756 38.3475C103.027 38.3475 101.579 36.8986 101.579 34.9103C101.579 32.8992 103.027 31.4301 104.756 31.4301C106.463 31.4301 107.803 32.8992 107.803 34.9103C107.803 36.8986 106.463 38.3475 104.756 38.3475ZM137.466 23.477H131.468V40.2486H133.97V33.8947H137.465C140.239 33.8947 142.968 31.8863 142.968 28.6865C142.968 25.4868 140.241 23.477 137.466 23.477ZM137.531 31.5603H133.97V25.8115H137.531C139.402 25.8115 140.465 27.361 140.465 28.6865C140.465 29.9852 139.402 31.5603 137.531 31.5603ZM153.002 29.1521C151.19 29.1521 149.313 29.9503 148.536 31.7199L150.758 32.647C151.233 31.7199 152.118 31.4167 153.045 31.4167C154.34 31.4167 155.656 32.1935 155.677 33.574V33.7471C155.224 33.4882 154.253 33.1005 153.067 33.1005C150.672 33.1005 148.233 34.4166 148.233 36.8758C148.233 39.1203 150.197 40.5652 152.397 40.5652C154.079 40.5652 155.008 39.8099 155.59 38.9244H155.676V40.2191H158.094V33.7887C158.095 30.813 155.871 29.1521 153.002 29.1521ZM152.699 38.3435C151.881 38.3435 150.736 37.933 150.736 36.9187C150.736 35.624 152.161 35.1276 153.391 35.1276C154.49 35.1276 155.009 35.3651 155.677 35.6884C155.483 37.2434 154.145 38.3435 152.699 38.3435ZM166.897 29.5183L164.028 36.7899H163.942L160.963 29.5183H158.267L162.733 39.6811L160.186 45.3346H162.797L169.681 29.5183H166.897ZM144.35 40.2486H146.852V23.477H144.35V40.2486Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4986 13.7423C64.4986 14.8666 64.1659 15.7614 63.4991 16.4296C62.7424 17.2238 61.755 17.6209 60.5422 17.6209C59.3803 17.6209 58.3916 17.2184 57.5799 16.4135C56.7669 15.6071 56.3604 14.609 56.3604 13.4176C56.3604 12.2249 56.7669 11.2268 57.5799 10.4218C58.3916 9.61549 59.3803 9.21301 60.5422 9.21301C61.1191 9.21301 61.6705 9.3257 62.1937 9.54975C62.7183 9.77515 63.1382 10.0743 63.4521 10.4486L62.7451 11.157C62.2125 10.5197 61.4786 10.2018 60.5408 10.2018C59.6929 10.2018 58.9604 10.4996 58.3419 11.0953C57.7234 11.691 57.4149 12.4651 57.4149 13.4163C57.4149 14.3675 57.7234 15.1416 58.3419 15.7373C58.9604 16.333 59.6929 16.6308 60.5408 16.6308C61.4397 16.6308 62.1897 16.3316 62.7894 15.7319C63.1784 15.3415 63.4038 14.7982 63.4642 14.1019H60.5408V13.1346H64.4409C64.4811 13.3452 64.4986 13.5478 64.4986 13.7423Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6836 10.3803H67.0183V12.932H70.324V13.8993H67.0183V16.4511H70.6836V17.4412H65.9839V9.39152H70.6836V10.3803Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.045 17.4412H74.0106V10.3803H71.7621V9.39152H77.2935V10.3803H75.045V17.4412Z",
    fill: "#FCFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2955 17.4412V9.39152H82.3299V17.4412H81.2955Z",
    fill: "#FCFCFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9171 17.4412H85.8827V10.3803H83.6342V9.39152H89.1657V10.3803H86.9171V17.4412Z",
    fill: "#FCFCFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6367 16.4014C98.8451 17.2145 97.8617 17.621 96.6851 17.621C95.5085 17.621 94.5251 17.2145 93.7349 16.4014C92.9433 15.5884 92.5489 14.5929 92.5489 13.4164C92.5489 12.2398 92.9433 11.2443 93.7349 10.4313C94.5251 9.61824 95.5085 9.21039 96.6851 9.21039C97.855 9.21039 98.8371 9.61958 99.6313 10.4366C100.426 11.2537 100.823 12.2465 100.823 13.4164C100.823 14.5929 100.427 15.5884 99.6367 16.4014ZM94.4983 15.7266C95.094 16.3303 95.8225 16.6309 96.6851 16.6309C97.5478 16.6309 98.2776 16.329 98.8719 15.7266C99.4676 15.1229 99.7668 14.3528 99.7668 13.4164C99.7668 12.4799 99.4676 11.7098 98.8719 11.1061C98.2776 10.5024 97.5478 10.2018 96.6851 10.2018C95.8225 10.2018 95.094 10.5037 94.4983 11.1061C93.9039 11.7098 93.6048 12.4799 93.6048 13.4164C93.6048 14.3528 93.9039 15.1229 94.4983 15.7266Z",
    fill: "#FCFCFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.274 17.4412V9.39152H103.533L107.445 15.6528H107.489L107.445 14.1019V9.39152H108.479V17.4412H107.399L103.306 10.8753H103.262L103.306 12.4263V17.4412H102.274Z",
    fill: "#FCFCFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4986 13.7423C64.4986 14.8666 64.1659 15.7614 63.4991 16.4296C62.7424 17.2238 61.755 17.6209 60.5422 17.6209C59.3803 17.6209 58.3916 17.2184 57.5799 16.4135C56.7669 15.6071 56.3604 14.609 56.3604 13.4176C56.3604 12.2249 56.7669 11.2268 57.5799 10.4218C58.3916 9.61549 59.3803 9.21301 60.5422 9.21301C61.1191 9.21301 61.6705 9.3257 62.1937 9.54975C62.7183 9.77515 63.1382 10.0743 63.4521 10.4486L62.7451 11.157C62.2125 10.5197 61.4786 10.2018 60.5408 10.2018C59.6929 10.2018 58.9604 10.4996 58.3419 11.0953C57.7234 11.691 57.4149 12.4651 57.4149 13.4163C57.4149 14.3675 57.7234 15.1416 58.3419 15.7373C58.9604 16.333 59.6929 16.6308 60.5408 16.6308C61.4397 16.6308 62.1897 16.3316 62.7894 15.7319C63.1784 15.3415 63.4038 14.7982 63.4642 14.1019H60.5408V13.1346H64.4409C64.4811 13.3452 64.4986 13.5478 64.4986 13.7423Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6836 10.3803H67.0183V12.932H70.324V13.8993H67.0183V16.4511H70.6836V17.4412H65.9839V9.39152H70.6836V10.3803Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.045 17.4412H74.0106V10.3803H71.7621V9.39152H77.2935V10.3803H75.045V17.4412Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2955 17.4412V9.39152H82.3299V17.4412H81.2955Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9171 17.4412H85.8827V10.3803H83.6342V9.39152H89.1657V10.3803H86.9171V17.4412Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6367 16.4014C98.8451 17.2145 97.8617 17.621 96.6851 17.621C95.5085 17.621 94.5251 17.2145 93.7349 16.4014C92.9433 15.5884 92.5489 14.5929 92.5489 13.4164C92.5489 12.2398 92.9433 11.2443 93.7349 10.4313C94.5251 9.61824 95.5085 9.21039 96.6851 9.21039C97.855 9.21039 98.8371 9.61958 99.6313 10.4366C100.426 11.2537 100.823 12.2465 100.823 13.4164C100.823 14.5929 100.427 15.5884 99.6367 16.4014ZM94.4983 15.7266C95.094 16.3303 95.8225 16.6309 96.6851 16.6309C97.5478 16.6309 98.2776 16.329 98.8719 15.7266C99.4676 15.1229 99.7668 14.3528 99.7668 13.4164C99.7668 12.4799 99.4676 11.7098 98.8719 11.1061C98.2776 10.5024 97.5478 10.2018 96.6851 10.2018C95.8225 10.2018 95.094 10.5037 94.4983 11.1061C93.9039 11.7098 93.6048 12.4799 93.6048 13.4164C93.6048 14.3528 93.9039 15.1229 94.4983 15.7266Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.274 17.4412V9.39152H103.533L107.445 15.6528H107.489L107.445 14.1019V9.39152H108.479V17.4412H107.399L103.306 10.8753H103.262L103.306 12.4263V17.4412H102.274Z",
    stroke: "#FCFCFD",
    strokeWidth: 0.223602,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_603_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8839 10.1132C14.4935 10.5264 14.2627 11.1677 14.2627 11.9981V41.6693C14.2627 42.5011 14.4935 43.141 14.8839 43.5543L14.9831 43.6509L31.6044 27.0296V26.8337V26.6378L14.9831 10.0152L14.8839 10.1132Z",
    fill: "url(#paint0_linear_603_451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.143 32.572L31.6035 27.0298V26.8339V26.638L37.1444 21.0972L37.2692 21.1683L43.8337 24.8979C45.7079 25.9632 45.7079 27.7059 43.8337 28.7725L37.2692 32.5022L37.143 32.572Z",
    fill: "url(#paint1_linear_603_451)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_603_451_google)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.27 32.5009L31.603 26.834L14.8838 43.5545C15.5009 44.2092 16.5219 44.2897 17.6717 43.6377L37.27 32.5009Z",
    fill: "url(#paint2_linear_603_451)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.27 21.1668L17.6717 10.0314C16.5219 9.37807 15.5009 9.45991 14.8838 10.1146L31.6043 26.8352L37.27 21.1668Z",
    fill: "url(#paint3_linear_603_451)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_603_451",
    x: 14.2627,
    y: 9.58055,
    width: 30.9766,
    height: 34.5075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.167702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_603_451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.167702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_603_451",
    result: "effect2_innerShadow_603_451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_603_451_google",
    x: 14.8838,
    y: 26.834,
    width: 22.3857,
    height: 17.2541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.167702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_603_451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_451",
    x1: 30.131,
    y1: 11.6842,
    x2: 7.61607,
    y2: 34.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_451",
    x1: 46.2734,
    y1: 26.8339,
    x2: 13.8118,
    y2: 26.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_451",
    x1: 34.1924,
    y1: 29.9115,
    x2: 3.6593,
    y2: 60.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_451",
    x1: 10.673,
    y1: 0.237377,
    x2: 24.3069,
    y2: 13.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayStoreButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play-store-button.4a1d4a28.svg";
export { ForwardRef as ReactComponent };